module.exports = __webpack_public_path__ + "img/founders.49cf1919.png";